import { isoDate } from './time.js';

// Round a Date to a time-of-day in decimal hours. 'floor' drops seconds (an
// entry's start is floored to the minute); 'ceil' rounds a partial minute up
// (its end is ceiled) so a few seconds of work still shows as a full minute.
function toMinuteHour(date, rounding) {
  let minutes = date.getHours() * 60 + date.getMinutes();
  if (
    rounding === 'ceil' &&
    (date.getSeconds() > 0 || date.getMilliseconds() > 0)
  )
    minutes += 1;
  return minutes / 60;
}

// Split one wall-clock segment into per-day {workDate, start, end} slices so a
// segment spanning midnight becomes one slice per calendar day.
export function splitSegment(segment) {
  const entries = [];
  let cursor = new Date(segment.start);
  while (cursor < segment.end) {
    const endOfDay = new Date(cursor);
    endOfDay.setHours(24, 0, 0, 0);
    const partEnd = segment.end < endOfDay ? segment.end : endOfDay;
    const start = toMinuteHour(cursor, 'floor');
    let end = toMinuteHour(partEnd, 'ceil');
    if (end === 0 && isoDate(partEnd) !== isoDate(cursor)) end = 24;
    if (end <= start) end = Math.min(24, start + 1 / 60);
    entries.push({ workDate: isoDate(cursor), start, end });
    cursor = new Date(endOfDay);
  }
  return entries;
}

// Every pending slice for a live timer: the completed (paused) segments plus
// the currently running segment (activeStart -> now), each split per day. This
// is exactly what the timer would save, so the calendar can preview it.
export function timerBlocks(segments, activeStart, now) {
  const all = activeStart
    ? [...segments, { start: activeStart, end: now }]
    : segments;
  return all.flatMap(splitSegment);
}
